import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'
import { isAndroid } from '../../utils/platformUtils'

const { width, height } = Dimensions.get('window')

const styles3 = StyleSheet.create({
    blockHeader: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
    },
    //Imagen de detalle de beneficios
    imageHeader: {
        aspectRatio: 1,
        borderRadius: 10,
        width: '90%',
    },
    invisibleContainer: {
        flex: 1,
        flexDirection: 'column',
        position: 'absolute',
        padding: 0,
        top: -10,
        width: width,
        justifyContent: 'center',
    },
    container: {
        flexDirection: 'row',
        width: '100%',
        marginTop: 0,
        paddingVertical: 15,
        zIndex: 1,
    },
    feedbackAssetContainer: {
        marginRight: 12,
        marginLeft: 12,
        zIndex: 2,
    },
    feedbackAsset: {
        width: 42,
        height: 42,
        zIndex: 2,
    },
    containerPoints: {
        borderTopStartRadius: 20,
        borderTopEndRadius: 20,
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        backgroundColor: theme.colors.colorPrimary,
        marginTop: 25,
        marginHorizontal: 0,
        paddingTop: 15,
        paddingBottom: 0,
        zIndex: 1,
    },
    levelKnowledgeBlock: {
        flex: 1,
        marginHorizontal: 0,
        paddingRight: 10,
        zIndex: 1,
    },
    alignStart: {
        alignItems: 'flex-start',
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerDataBaseline: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colorText,
        marginRight: 5,
        marginTop: 5,
    },
    subtitle: {
        fontSize: 13,
        color: colorText,
    },
    value: {
        fontSize: 28,
        fontWeight: 'bold',
        color: colorText,
    },
})

export default styles3
